<template src="./html/Index.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Create from './Create.vue'

	import Datatable from './Datatable.vue'

	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				resource: 'teams',
			}
		},
		components: {
			'create': Create,
			'datatable': Datatable,
		},

		methods: {
			reload() {
				this.$nextTick( () => this.$refs.datatable.reload())
			},
			destroy(team) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/projects/'+that.resource+'/' + team.id)
							.then(response => {
								that.$refs.datatable.reload()
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}).catch(function(response) {
								console.log(response)
								swal({
									title: response.statusText,
									text: response.bodyText,
									type: "warning"
								});
							})
						})
					}
				}]).catch(swal.noop)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/teams/views/Index.vue